import { Marker } from 'maplibre-gl';
import { createRoot } from 'react-dom/client';

import { REGIONS, RISK_COLORS } from '@App/pages/RiskDataPage/risk-data-page.constants';
import { HAZARD_CATEGORIES } from '@App/components/AdaptationListComponent/adaptation-list-component.constants';
import RiskMarker from '@App/components/RiskMarker/RiskMarker';

function getMaxValue(data) {
  const allValues = Object.values(data).flatMap(d => d.map(item => item.value));
  return Math.ceil(Math.max(...allValues));
}

function createRiskMarkers(map, riskData, selectedRisk, selectedHorizon, selectedScenario) {
  return REGIONS.map((region) => {
    const riskInfo = riskData?.[region?.district]?.[selectedHorizon?.id]?.[selectedScenario?.id]?.[selectedRisk];
    const icon = HAZARD_CATEGORIES.find(hazard => hazard.id === selectedRisk)?.icon;

    if (!riskInfo || !icon) {
      return null;
    }

    const markerContainer = document.createElement('div');

    const root = createRoot(markerContainer);
    root.render(<RiskMarker icon={icon} backgroundColor={RISK_COLORS[riskInfo]} />);

    const marker = new Marker({
      element: markerContainer,
    });

    marker.setLngLat({ lat: region.lat, lng: region.lng }).addTo(map);

    marker.on('remove', () => {
      root.unmount();
    });

    return marker;
  });
}

export {
  createRiskMarkers,
  getMaxValue,
};